import React from 'react';

export function AlphaFoldPaperLink(): JSX.Element {
  return (
    <a href="https://www.nature.com/articles/s41586-021-03819-2" target="_blank" rel="noopener noreferrer">
      AlphaFold2
    </a>
  );
}
